import { types } from 'mobx-state-tree';

export const PricingStrategy = types.model('Item', {
  currency: types.optional(types.string, ''),
  id: types.optional(types.string, ''),
  profit: types.maybe(types.union(types.number, types.string)),
  profitInPercents: types.maybe(types.union(types.number, types.string)),
  salePrice: types.maybe(types.union(types.number, types.string)),
  sourcePrice: types.optional(types.number, 0),
  profitType: types.optional(types.number, 1),
  // strategy: types.optional(types.string,"826"),
  strategyDownCurrencyUnits: types.maybe(types.number),
  strategyDownDays: types.maybe(types.number),
  strategyMaximalProfit: types.maybe(types.number),
  strategyMinimalProfit: types.maybe(types.number),
  strategyOptimalProfit: types.maybe(types.number),
  strategyUpCurrencyUnits: types.maybe(types.number),
  strategyUpTimes: types.maybe(types.number),
  strategy: types.maybe(types.string),
  strategyBreakEven: types.maybe(types.union(types.number, types.string)),
  strategyProfit: types.maybe(types.union(types.number, types.string)),// delete if not used anywhere else
}).views(self => ({
  get strategyInPercents(){
    return self.profitType === 1;
  }
}));
